module.exports = __webpack_public_path__ + "img/photo4.ad863537.png";